import { useEffect, useState } from "react";
import { useSettings } from "@/context/SettingsContext";
import { getConsent } from "@/components/CookieConsent";

// Injects Google Search Console verification (always, when set) and
// Google Analytics 4 (only after the visitor accepts analytics cookies).
export default function Analytics() {
  const settings = useSettings();
  const gaId = settings?.google_analytics_id?.trim();
  const scCode = settings?.google_search_console?.trim();
  const [consent, setConsent] = useState(getConsent());

  // Search Console verification meta tag
  useEffect(() => {
    if (!scCode) return;
    let tag = document.querySelector('meta[name="google-site-verification"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "google-site-verification");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", scCode);
  }, [scCode]);

  // React to cookie consent changes
  useEffect(() => {
    const handler = (e) => setConsent(e.detail);
    window.addEventListener("mg-consent-change", handler);
    return () => window.removeEventListener("mg-consent-change", handler);
  }, []);

  // GA4 — load only with valid ID and accepted analytics consent
  useEffect(() => {
    if (!gaId || consent !== "accepted") return;
    if (document.getElementById("ga4-src")) return;

    const s = document.createElement("script");
    s.id = "ga4-src";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(s);

    const inline = document.createElement("script");
    inline.id = "ga4-init";
    inline.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${gaId}',{anonymize_ip:true});`;
    document.head.appendChild(inline);
  }, [gaId, consent]);

  return null;
}
